export function buildMailtoLink(recipient: string, subject: string, body: string): string {
	const query = `subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
	return `mailto:${recipient}?${query}`;
}
